// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".attribute-group[data-v-334ab1a1],.place-attributes[data-v-334ab1a1]{display:flex;flex-direction:column;gap:.5rem}.attribute-group-name[data-v-334ab1a1]{font-weight:600}.attribute-property[data-v-334ab1a1]{display:flex;justify-content:space-between;gap:.5rem}.attribute-property-value[data-v-334ab1a1]{font-weight:600;white-space:nowrap}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
